import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_INVESTCORE_TRANSACTION_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_TRANSACTION_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_TRANSACTION_LIST_API_ID,
  (params: {}) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/transactions`,
      params: { ordering: '-date', ...params },
    }),
    method: 'GET',
  })
);

export default apiCall;
